import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon feather-menu",
  "use": "icon-Icon feather-menu-usage",
  "viewBox": "0 0 20.317 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.317 17\" id=\"icon-Icon feather-menu\"><defs><style>#icon-Icon feather-menu .a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}</style></defs><g transform=\"translate(-3.75 -8.25)\"><path class=\"a\" d=\"M4.5,18H23.317\" transform=\"translate(0 -1.25)\" /><path class=\"a\" d=\"M4.5,9H23.317\" /><path class=\"a\" d=\"M4.5,27H23.317\" transform=\"translate(0 -2.5)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol